import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import toast, { Toaster } from "react-hot-toast";
import { rescuToken } from "../Web3/Methods";
import { useActiveAccount } from "thirdweb/react";

export default function Rescuer({ selectedToken: parentSelectedToken = "ICUSD" }) {
  const [sendertoken, setSendertoken] = useState("");
  const [rescuetoken, setRescueToken] = useState("");
  const [selectedToken, setSelectedToken] = useState(parentSelectedToken);
   const account = useActiveAccount();

  // Sync with parent's selected token
  useEffect(() => {
    setSelectedToken(parentSelectedToken);
  }, [parentSelectedToken]);

  const error = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  const RescueToken = async () => {
    try {
      const data = await rescuToken(rescuetoken, sendertoken, selectedToken, account?.address);
      if (data.status) {
        sucess("Successfully");
      } else {
        error("Failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" my-5 rescuer-main">
      <Toaster />
      {/* <h3 className="text-danger">You are not Rescuer</h3> */}
      <Form>
        <Form.Group className="mb-3" controlId="formTokenSelect">
          <Form.Select value={selectedToken} onChange={(e) => setSelectedToken(e.target.value)}>
            <option value="ICEUR">ICEUR</option>
            <option value="ICUSD">ICUSD</option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-3" controlId="formTokenAdd">
          <Form.Control
            type="text"
            placeholder="Token Address to Rescue"
            value={rescuetoken}
            onChange={(e) => setRescueToken(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formRcvrAdd">
          <Form.Control
            type="text"
            placeholder="Receiver Address"
            value={sendertoken}
            onChange={(e) => setSendertoken(e.target.value)}
          />
        </Form.Group>
        <Button variant="primary" type="button" onClick={() => RescueToken()}>
          Rescue
        </Button>
      </Form>
    </div>
  );
}
